import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    redText: {
        color: "rgb(255, 0, 0)",
    },
    boldText: {
        fontWeight: "bold",
    },
    ContentLineHight: {
        lineHeight: "23px",
    },
    mb5: {
        marginBottom: "5px",
    },
});

function Form017SubmittedDialog({ formOpen, onConfirm }) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    return (
        <React.Fragment>
            <Dialog
                // onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                open={formOpen}
            >
                <DialogTitle id="simple-dialog-title">
                    {t("common.portal.successfulFormSubmission")}
                </DialogTitle>
                <DialogContent className={classes.ContentLineHight}>
                    <Typography>
                        {t("Form017.submittedDialog.note1")}
                    </Typography>
                    <Typography className={classes.mb5}>
                        {t("Form017.submittedDialog.note2")}
                        <span
                            className={
                                i18n.language === "en"
                                    ? classes.boldText
                                    : classes.redText
                            }
                        >
                            {t("Form017.submittedDialog.note3")}
                        </span>
                        {t("Form017.submittedDialog.note4")}
                        <span
                            className={
                                i18n.language === "en"
                                    ? classes.redText
                                    : classes.boldText
                            }
                        >
                            {t("Form017.submittedDialog.note5")}
                        </span>
                        {t("Form017.submittedDialog.note6")}
                    </Typography>
                    <Grid container>
                        <Grid item xs={1}>
                            ({i18n.language == "en" ? "a" : "i"})
                        </Grid>
                        <Grid item xs={11}>
                            {t("Form017.submittedDialog.note7")}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={1}>
                            ({i18n.language == "en" ? "b" : "ii"})
                        </Grid>
                        <Grid item xs={11}>
                            {t("Form017.submittedDialog.note8")}
                        </Grid>
                    </Grid>
                    {i18n.language !== "en" ? (
                        <>
                            <Typography>
                                {t("Form017.submittedDialog.note9")}
                            </Typography>
                            <Typography>
                                {t("Form017.submittedDialog.note10")}
                            </Typography>
                            <Typography>
                                {t("Form017.submittedDialog.note11")}
                            </Typography>
                            <Typography>
                                {t("Form017.submittedDialog.note12")}
                            </Typography>
                            <Typography>
                                {t("Form017.submittedDialog.note13")}
                            </Typography>
                        </>
                    ) : null}
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={onConfirm} color="success">
                        <b>{t("common.portal.confirm")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default Form017SubmittedDialog;
